import React, { useEffect, useState } from "react";
import { Calendar } from "primereact/calendar";
import { CheckCircle, XCircle } from "react-bootstrap-icons";
import { FiClipboard, FiSettings } from "react-icons/fi";
import { FiCalendar, FiEye, FiPackage } from "react-icons/fi";
import { MdSpeed } from "react-icons/md";
import InfoHeader from "../components/InfoHeader";
// import { Button } from "react-bootstrap";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import axios from "axios";
import CleaningHistoryModal from "../components/MagneticGrillCleanModal";
import { fetchCleaningActivityDataTurmeric } from "../components/API/Api";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const Packaging = () => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [shiftFilter, setShiftFilter] = useState("");
  const [data, setData] = useState([]);
  const [summaryData, setSummaryData] = useState({
    total_metal_calibration: 0,
    total_coin_metal_calibration: 0,
    total_tape_missalignment: 0,
    total_packet_count: 0,
    last_metal_calibration_time: "---",
    last_coin_metal_calibration_time: "---"
  });
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    rowsPerPage: 10,
  });
  const [packagingCleaningHistory, setPackagingCleaningHistory] = useState({
    metal_calibration_history: [],
    coin_metal_calibration_history: []
  });
  const [tapeMissalignmentHistory, setTapeMissalignmentHistory] = useState([]);
  const [showTapeMissalignmentModal, setShowTapeMissalignmentModal] = useState(false);
  const [showPackagingModal, setShowPackagingModal] = useState(false);
  const [currentPackagingType, setCurrentPackagingType] = useState(null);
  const [currentCleaningComponent, setCurrentCleaningComponent] = useState(null);
  const [currentCleaningType, setCurrentCleaningType] = useState(null);

  const formatIfTimestamp = (
    val,
    options = { showDate: true, showTime: true }
  ) => {
    if (
      typeof val === "string" &&
      (val.includes("T") || val.match(/\d{2}:\d{2}/))
    ) {
      const date = new Date(val);
      if (!isNaN(date)) {
        const formattedDate = options.showDate
          ? date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          : "";

        const formattedTime = options.showTime
          ? date.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          })
          : "";

        if (options.showDate && options.showTime) {
          return `${formattedDate}, ${formattedTime}`;
        }
        return formattedDate || formattedTime;
      }
    }
    return val;
  };

  // Function to format date in YYYY-MM-DD format for API
  const formatDateForAPI = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Fetch data from real API
  const fetchData = async (
    page = 1,
    startDate,
    endDate,
    rowsPerPage = 10,
    shift = ""
  ) => {
    setLoading(true);
    try {
      // Format dates for API
      const formattedStartDate = formatDateForAPI(startDate);
      const formattedEndDate = formatDateForAPI(endDate);

      // Construct API URL with query parameters
      const apiUrl = `https://g1e3kx0ij7.execute-api.ap-south-1.amazonaws.com/testing/packaging_history?start_date=${formattedStartDate}&end_date=${formattedEndDate}&no_of_records=${rowsPerPage}&page_no=${page}`;

      const response = await axios.get(apiUrl);

      if (response.data && response.data.body && response.data.body.success) {
        const { data, summary, page_no, no_of_records, total_records, total_pages } = response.data.body.success;

        const tapeMissalignmentData = response?.data.body.success.tape_missalignment_history || [];
        setTapeMissalignmentHistory(tapeMissalignmentData.reverse());
        // ✅ MAIN FIX: Extract cleaning history from main response
        const cleaningHistoryData = {
          metal_calibration_history: (response.data.body.success.metal_calibration_history).reverse() || [],
          coin_metal_calibration_history: (response.data.body.success.coin_metal_calibration_history).reverse() || [],
        };
        // Filter by shift if required
        const filteredData = shift
          ? data.filter(item => item.shift === shift)
          : data;

        // Transform data for table display
        const transformedData = filteredData.map((item, index) => {
          const parts = item.timestamp_range?.split(" ") || [];
          const dateStr = parts[0] || "";
          let timeRange = "";

          try {
            if (parts.length >= 7) {
              timeRange = `${parts[1]} ${parts[2]} to ${parts[5]} ${parts[6]}`;
            } else {
              timeRange = item.timestamp_range; // fallback if not as expected
            }
          } catch (e) {
            console.error("Error parsing timestamp_range:", e);
            timeRange = item.timestamp_range;
          }

          return {
            id: (page_no - 1) * no_of_records + index + 1,
            dateTime: item.timestamp_range,
            date: dateStr,
            time: timeRange,
            packetCount: item.packet_count,
            metalCalibrationCount: item.metal_calibration_count,
            coinMetalCalibrationCount: item.coin_metal_calibration_count,
            tapeMissalignmentCount: item.tape_missalignment_count,
            shift: item.shift,
          };
        });

        // ✅ UPDATED: Set cleaning history from main response
        setPackagingCleaningHistory(cleaningHistoryData);

        setData(transformedData);
        setSummaryData(summary);

        setPagination({
          currentPage: page_no,
          totalPages: total_pages,
          totalRecords: total_records,
          rowsPerPage: no_of_records,
        });

        setError(null);
      } else {
        throw new Error("Invalid response structure");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError(`Error fetching data: ${err.message}`);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadExcel = async () => {
    try {
      setLoading(true);

      const startDate = dateRange[0] ? formatDateForAPI(dateRange[0]) : null;
      const endDate = dateRange[1] ? formatDateForAPI(dateRange[1]) : null;

      if (!startDate || !endDate) {
        setError('Please select a valid date range');
        return;
      }

      // Fetch data - Packaging के लिए section change
      const result = await fetchCleaningActivityDataTurmeric({
        startDate: startDate,
        endDate: endDate,
        section: "packaging"  // Changed to "packaging"
      });

      let data;
      if (result?.body?.success?.data) {
        data = result.body.success.data;
      } else if (result?.data) {
        data = result.data;
      } else if (result?.body?.data) {
        data = result.body.data;
      } else {
        setError("No data received from server");
        return;
      }

      if (!data) {
        setError("No data received from server");
        return;
      }

      // Create workbook
      const workbook = XLSX.utils.book_new();

      // Helper function for sheet names
      const getSheetName = (key) => {
        switch (key) {
          case 'metal_detector': return 'Metal Detector';
          case 'coin_metal_detector': return 'Coin Metal Detector';
          case 'stick_metal_detector': return 'Stick Metal Detector';
          default: return key;
        }
      };

      // Process all detector types - Updated keys for Packaging
      ['metal_detector', 'coin_metal_detector', 'stick_metal_detector'].forEach(detectorKey => {
        let detectorRecords = data[detectorKey];

        if (!detectorRecords || detectorRecords.length === 0) {
          console.warn(`No records found for ${detectorKey}`);
          const emptySheet = XLSX.utils.json_to_sheet([{
            'Sr. No.': 'No data available',
            Date: 'No data available',
            Time: 'No data available',
            Image: 'No data available'
          }]);
          XLSX.utils.book_append_sheet(
            workbook,
            emptySheet,
            getSheetName(detectorKey)
          );
          return;
        }

        const formattedRecords = detectorRecords.map((record, index) => ({
          'Sr. No.': index + 1,
          Date: record.Date,        // Direct API field
          Time: record.Time,        // Direct API field  
          Image: record.Image,      // Direct API field
          Detector: getSheetName(detectorKey)  // Changed to "Detector"
        }));

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedRecords);

        // Set column widths
        const colWidths = [
          { wch: 8 },  // Sr. No.
          { wch: 12 }, // Date
          { wch: 15 }, // Time
          { wch: 60 }, // Image URL
          { wch: 20 }  // Detector (increased width for longer names)
        ];
        worksheet['!cols'] = colWidths;

        // Add sheet to workbook
        const sheetName = getSheetName(detectorKey);
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
      });

      // Generate and save file - Updated filename
      const wbout = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const filename = `Packaging_Activity_${startDate}_to_${endDate}.xlsx`;
      saveAs(blob, filename);

      console.log('Excel file downloaded successfully');

    } catch (error) {
      console.error('Error downloading Excel file:', error);
      setError('Failed to download Excel file. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCleaningHistoryClick = (component, type) => {
    setShowPackagingModal(true);
  };

  // 🆕 Auto filter function when date range changes
  const handleDateRangeChange = (e) => {
    const newDateRange = e.value;
    setDateRange(newDateRange);

    // Auto apply filter when both dates are selected
    if (newDateRange && newDateRange.length === 2 && newDateRange[0] && newDateRange[1]) {
      fetchData(1, newDateRange[0], newDateRange[1], pagination.rowsPerPage, shiftFilter);
    }
  };

  // 🆕 Clear filter function
  const clearDateFilter = () => {
    const today = new Date();
    setDateRange([today, today]);
    fetchData(1, today, today, pagination.rowsPerPage, shiftFilter);
  };

  // Initial data load for today's date
  useEffect(() => {
    const today = new Date();
    setDateRange([today, today]);
    fetchData(1, today, today, pagination.rowsPerPage, shiftFilter);
  }, []); // Empty dependency array means this runs once on component mount

  function MetricCard({ title, value, icon, isTimestamp = false }) {
    return (
      <div className="metric-card">
        <div className="p-3">
          <div className="metric-title">{title}</div>
          <div className="d-flex align-items-center justify-content-between">
            <div className={`metric-value ${isTimestamp ? "timestamp" : ""}`}>
              {value}
            </div>
            <div>{icon}</div>
          </div>
        </div>
      </div>
    );
  }

  const dateFilterContainerStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "start",
    alignItems: "center",
    padding: "0 15px",
    borderRadius: "8px",
    marginBottom: "20px",
    gap: "15px",
  };

  const tableHeadingStyle = {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "18px",
    marginBottom: "15px",
    color: "#007BFF",
    justifyContent: "end",
    alignItems: "center",
  };

  const getDateRangeText = () => {
    if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      const formatDate = (date) => {
        return date.toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      };

      return `${formatDate(dateRange[0])} to ${formatDate(dateRange[1])}`;
    }
    return "Today";
  };

  const tableContainerStyle = {
    width: "100%",
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    padding: "15px",
    display: "flex",
    flexDirection: "column",
    minHeight: "100px",
    marginBottom: "1rem",
  };

  const onPageChange = (event) => {
    const newPage = event.page + 1;
    const newRowsPerPage = event.rows;

    setPagination((prev) => ({
      ...prev,
      currentPage: newPage,
      rowsPerPage: newRowsPerPage,
    }));

    fetchData(newPage, dateRange[0], dateRange[1], newRowsPerPage, shiftFilter);
  };

  // Get today's date for display
  const getTodayDateFormatted = () => {
    const today = new Date();
    return today.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }) + ", " + today.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div>
      <InfoHeader />
      <div className="col-lg-12">
        <div className="card border dashboard-card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h2 className="fs-5 fw-semibold mb-0">Packaging</h2>
          </div>
          <div className="card-body">
            <div style={dateFilterContainerStyle}>
              <div className="d-flex align-items-center">
                <FiCalendar className="me-2" size={18} />
                <span className="fw-semibold">Filter by Date Range:</span>
              </div>
              <div className="d-flex flex-wrap align-items-center gap-2">
                <Calendar
                  value={dateRange}
                  onChange={handleDateRangeChange} // 🆕 Updated to use new handler
                  selectionMode="range"
                  readOnlyInput
                  showIcon
                  placeholder="Select Date Range"
                  maxDate={new Date()}
                  className="p-calendar-range"
                  dateFormat="dd/mm/yy"
                  hideOnRangeSelection={true} // 🆕 Calendar will close after range selection
                />
                {/* 🆕 Clear Filter Button */}
                <Button
                  variant="secondary"
                  icon="pi pi-times"
                  onClick={clearDateFilter}
                  disabled={loading}
                  style={{
                    backgroundColor: "#2196f3",
                    borderColor: "#2196f3",
                    borderRadius: "0px",
                    color: "white"
                  }}
                />
                <Button
                  label={loading ? "Downloading..." : "Metal Detector Calibration Activity"}
                  icon={loading ? "pi pi-spin pi-spinner" : "pi pi-download"}
                  onClick={handleDownloadExcel}
                  disabled={loading || !dateRange[0] || !dateRange[1]}
                  className="p-button-md p-button-primery"
                  style={{
                    marginLeft: '10px',
                    minWidth: '200px'
                  }}
                  tooltip={
                    !dateRange[0] || !dateRange[1]
                      ? "Please select a date range first"
                      : "Download packaging activity data as Excel file for metal detector, coin metal detector and stick metal detector"
                  }
                  tooltipOptions={{ position: 'top' }}
                />
              </div>
              {/* <div style={tableHeadingStyle}>
                <div className="small text-muted mt-1">
                  Showing data for: {getDateRangeText()}
                  {shiftFilter ? ` | Shift: ${shiftFilter}` : ""}
                </div>
              </div> */}
            </div>

            <div className="row g-3">
              <div className="col-md-3"
                // onClick={(e) => {
                //   e.stopPropagation();
                //   handleCleaningHistoryClick("metal_calibration", "packaging");
                // }}
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentCleaningComponent("metal_calibration_history");
                  setCurrentCleaningType("packaging");
                  setShowPackagingModal(true);
                }}
              >
                <MetricCard
                  title="Metal detector calibration activity (CCP)"
                  value={` ${summaryData.last_metal_calibration_time === null ? "No data" : formatIfTimestamp(summaryData.last_metal_calibration_time)}`}
                  icon={<MdSpeed className="metric-icon green" />}
                />
              </div>
              <div className="col-md-3"
                // onClick={(e) => {
                //   e.stopPropagation();
                //   handleCleaningHistoryClick("coin_metal_calibration", "packaging");
                // }}
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentCleaningComponent("coin_metal_calibration_history");
                  setCurrentCleaningType("packaging");
                  setShowPackagingModal(true);
                }}
              >
                <MetricCard
                  title="Rejector coil and metal detector calibration"
                  value={` ${summaryData.last_coin_metal_calibration_time === null ? "No data" : formatIfTimestamp(summaryData.last_coin_metal_calibration_time)}`}
                  icon={<FiSettings className="metric-icon green" />}
                />
              </div>
              <div className="col-md-3"
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentCleaningComponent("tape_missalignment");
                  setCurrentCleaningType("packaging");
                  setShowTapeMissalignmentModal(true); // Fix: Use proper setter function
                }}
              >
                <MetricCard
                  title="Tape Missalignment count"
                  value={summaryData.total_tape_missalignment}
                  icon={<FiPackage className="metric-icon green" />}
                // isEyeIcon={true}
                />
              </div>
            </div>

            {/* Table */}
            <div style={tableContainerStyle}>
              <div
                style={{
                  display: "flex",
                  marginBottom: "1rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <h4 style={tableHeadingStyle}>Packaging Data</h4>
                </div>
                <div className="ms-auto d-flex align-items-center">
                  <span className="me-2" style={{ width: "7rem" }}>
                    Filter by Shift:
                  </span>
                  <Dropdown
                    value={shiftFilter}
                    options={[
                      { label: "All Shifts", value: "" },
                      { label: "Shift I", value: "I" },
                      { label: "Shift II", value: "II" },
                    ]}
                    onChange={(e) => {
                      setShiftFilter(e.value);
                      // Apply shift filter immediately
                      if (dateRange && dateRange.length === 2) {
                        fetchData(
                          1,
                          dateRange[0],
                          dateRange[1],
                          pagination.rowsPerPage,
                          e.value
                        );
                      }
                    }}
                    placeholder="Select Shift"
                    className="p-dropdown-sm"
                    style={{ minWidth: "10rem" }}
                  />
                </div>
              </div>

              {/* DataTable with API data */}
              <DataTable
                value={data}
                scrollable
                scrollHeight="300px"
                className="p-datatable-sm p-datatable-striped"
                paginator
                first={(pagination.currentPage - 1) * pagination.rowsPerPage}
                rows={pagination.rowsPerPage}
                rowsPerPageOptions={[5, 10, 20, 50]}
                totalRecords={pagination.totalRecords}
                onPage={onPageChange}
                loading={loading}
                emptyMessage="No records found"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              >
                <Column field="id" header="Sr. No." style={{ width: "5%" }} />
                <Column field="date" header="Date" />
                <Column field="time" header="Time Range" />
                <Column
                  field="metalCalibrationCount"
                  header="Metal Detector Calibration Count"
                  bodyStyle={{ backgroundColor: "rgba(222, 234, 252, 0.7)", textAlign: "right" }}
                />
                <Column
                  field="coinMetalCalibrationCount"
                  header="Rejector Coil and Metal Detector Calibration Count"
                  bodyStyle={{ backgroundColor: "rgb(255, 221, 193)", textAlign: "right" }}
                />
                <Column
                  field="tapeMissalignmentCount"
                  header="Tape Missalignment Count"
                  bodyStyle={{ backgroundColor: "rgb(231, 255, 193)", textAlign: "right" }}
                />
                <Column
                  field="shift"
                  header="Shift"
                  bodyStyle={{
                    backgroundColor: "rgb(214, 249, 255)",
                    textAlign: "center",
                  }}
                />
              </DataTable>
            </div>
          </div>
        </div>
      </div>
      {/* <CleaningHistoryModal
        showModal={showPackagingModal}
        onHide={() => setShowPackagingModal(false)}
        currentComponent={currentPackagingType}
        packagingCleaningHistory={packagingCleaningHistory}
        cleaningType="packaging"
      /> */}
      <CleaningHistoryModal
        showModal={showPackagingModal}
        onHide={() => setShowPackagingModal(false)}
        currentComponent={currentCleaningComponent}
        packagingCleaningHistory={packagingCleaningHistory}
        cleaningType="packaging"
      />
      <CleaningHistoryModal
        showModal={showTapeMissalignmentModal}
        onHide={() => setShowTapeMissalignmentModal(false)}
        currentComponent={currentCleaningComponent}
        packagingTapeMissAlignData={tapeMissalignmentHistory}
        cleaningType="tape_missalignment"
      />
    </div>
  );
};

export default Packaging;